<div class="py-40 px-10 text-center text-xl text-bold">
  @if (panelState === 'loading') {
    <div class="flex flex-col justify-center items-center py-6">
      <div class="py-12 text-6xl font-bold">
        {{ 'payment.tcpos-sco.creating-order' | translate }}
      </div>
    </div>
  }

  @if (panelState === 'waiting') {
    <div class="flex justify-center items-center py-6 text-6xl font-bold">
      {{ terminalInstructionMessage() ?? ('payment.tcpos-sco.title' | translate) }}
    </div>
    @if (statusMessage) {
      <div class="text-6xl mt-24">{{ statusMessage }}</div>
    }
  }

  @if (panelState === 'success') {
    <div class="flex justify-center items-center py-6 text-6xl font-bold text-success-800">
      {{ statusMessage }}
    </div>
  }

  @if (panelState === 'fail' || panelState === 'error' || panelState === 'cancelled') {
    @if (errorMessage) {
      <div class="mt-12 text-center text-6xl text-error-800">{{ errorMessage }}</div>
    }
    <div class="mt-12 flex flex-row justify-center">
      <app-button-atom
        size="XXL"
        thickSize="XXL"
        [label]="'payment.tcpos-sco.retry' | translate"
        (click)="retryPayment()"
        type="primary"
      ></app-button-atom>
    </div>
    <div class="mt-12 flex flex-row justify-center">
      <app-button-atom
        size="XXL"
        thickSize="XXL"
        [label]="'payment.tcpos-sco.cancel' | translate"
        (click)="cancelPayment()"
        type="light"
      ></app-button-atom>
    </div>
    <div class="mt-12 flex flex-row justify-center">
      <app-button-atom
        size="XXL"
        thickSize="XXL"
        [label]="'payment.tcpos-sco.back-to-cart' | translate"
        (click)="backToCart()"
        type="light"
      ></app-button-atom>
    </div>
  }
</div>

@if (loadKioskResetTimer) {
  <app-kiosk-cart-reset-timer-block
    [config]="{ 'wait_for_user_interaction_to_display_modal': false }"
  ></app-kiosk-cart-reset-timer-block>
}
